module.exports = __webpack_public_path__ + "static/media/biggs.27d93900.jpg";